import React from 'react'
import Jed from 'jed'
import { sprintf } from 'sprintf-js'

let i18n

const initTranslations = (translations = {}) => {

  i18n = new Jed(translations)
}

const format = (string, args) => {
  try {
    return sprintf(string, args)
  } catch (error) {
    return string
  }
}

const gettext = (string, args) => {
  let trans = i18n.gettext(string)

  if (args) {
    trans = format(trans, args)
  }

  return trans
}

const ngettext = (singular, plural, count = 1, args) => {
  let trans = i18n.ngettext(singular, plural, count)

  trans = format(trans, args || count)

  return trans
}

const pgettext = (key, context, args) => {
  let trans = i18n.pgettext(context, key)

  if (args) {
    trans = format(trans, args)
  }

  return trans
}

const renderComponent = (string, args) => {
  const re = /\[([\w\d]+)(:(.[^\]]+))?\]/g
  const children = []

  function getPart() {
    return re.exec(string)
  }

  function addToChildren(text, dom = 'span') {
    let element

    if (React.isValidElement(dom)) {
      element = React.cloneElement(dom, null, text && text.trim())
    } else {
      element = React.createElement(dom, null, text)
    }

    children.push(element)
  }

  let match = getPart()
  let lastIndex = 0

  while (match && match.length) {
    const [group, key, subgroup, text] = match
    const { input, index } = match
    const component = args && args[key]

    // create string before match [key: text]
    if (index > lastIndex) {
      addToChildren(input.substring(lastIndex, index))
    }

    // create string for match [key: text]
    if (component) {
      addToChildren(text && text.trim(), component)
    } else {
      addToChildren(group)
    }

    lastIndex = index + group.length
    match = getPart()
  }

  // create string after last match
  if (lastIndex < string.length) {
    addToChildren(string.substring(lastIndex, string.length))
  }

  return React.createElement(
    'span',
    null,
    children.map((child, key) => React.cloneElement(child, { key: key })),
  )
}

// TODO
// - improve to use sprintf
// - try to not insert a root span element
// *****************
// const test = React.createElement('div', null, [
//   React.createElement('span', null, 'First string'),
//   React.createElement('span', null, 'second string'),
//   React.createElement('span', null, 'third string'),
// ]);
const tComponent = (string, args) => {
  const trans = gettext(string, args)
  return renderComponent(trans, args)
}

const tnComponent = (singular, plural, count = 1, args) => {
  const trans = ngettext(singular, plural, count, args)
  return renderComponent(trans, args)
}

export const t = gettext
export const tp = pgettext
export const tn = ngettext
export const tc = tComponent
export const tnc = tnComponent
export const setTranslations = initTranslations
